<template>
  <div v-if="AppState.showSettings">
    <!-- *************** EDITOR CODE ************** -->
    <div class="btn-settings">
      <button class="btn-icon" @click.prevent.stop="moveBlockUp" v-show="order !== 0"><i class="ti-angle-up"></i></button>
      <button class="btn-icon" @click.prevent.stop="moveBlockDown" v-show="order !== AppState.currentPage.blocks.length - 1"><i class="ti-angle-down"></i></button>
      <button class="btn-icon" @click.prevent.stop="popSettingsOpen"><i class="ti-settings"></i></button>
      <button class="btn-icon red" @click.prevent.stop="deleteBlock"><i class="ti-trash"></i></button>
    </div>

    <!-- SETTINGS POPUP -->
    <v-dialog v-model="dialogOpen" lazy scrollable persistent full-width>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>

              <v-flex xs4 md3 lg2>
                <v-navigation-drawer permanent stateless value="true">
                  <v-toolbar flat>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-title class="title"> Settings </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-list dense class="pt-0">
                    <v-list-tile @click="switchMenu('general', null)" :value="activeMenu === 'general'">
                      <v-list-tile-content> <v-list-tile-title>General</v-list-tile-title> </v-list-tile-content>
                    </v-list-tile>

                    <v-list-group v-for="arrayed in settings.filter(el => el.type=='array')" :key="arrayed.el" :value="arrayed.el === activeMenu">
                      <v-list-tile slot="item">
                        <v-list-tile-content>
                          <v-list-tile-title>{{ arrayed.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-icon>keyboard_arrow_down</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-list-tile v-for="(child, ind) in block.options[arrayed.el]" :value="arrayed.el === activeMenu && activeItem.id === child.id" v-bind:key="child.id" @click="switchMenu(arrayed.el, child.id)">
                        <v-list-tile-content>
                          <v-list-tile-title>{{ child.id }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="ind !== 0">
                          <v-btn icon ripple @click.stop.prevent="removeThis(arrayed, child.id)"> <v-icon color="red lighten-1">delete</v-icon> </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-list-tile @click="addNew(arrayed)">
                        <v-list-tile-content> <v-list-tile-title>Add New</v-list-tile-title> </v-list-tile-content>
                      </v-list-tile>
                    </v-list-group>
                  
                  </v-list>
                </v-navigation-drawer>
              </v-flex>

              <v-flex xs8 md9 lg10>
                <block-settings-elements :activeSettings="activeSettings" :activeItem="activeItem" @afterUpload="afterUpload"></block-settings-elements>
              </v-flex>

            </v-layout>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="popSettingsClose">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- SETTINS POPUP -->
  </div>
</template>

<script>
import BlockSettingsElements from "./_BlockSettingsElements";
import AppState from "../util/AppState";

export default {
  props: ["block", "order"],
  data() {
    return {
      dialogOpen: false,
      activeMenu: "general",
      activeItem: null,
      activeSettings: [],
      AppState
    };
  },
  computed: {
    settings() {
      return this.block.settings;
    }
  },
  components: {
    BlockSettingsElements
  },
  mounted() {
    // this.editables = [this.$refs.title, this.$refs.subtitle];
    this.activeSettings = this.settings.filter(it => it.type !== "array");
    this.activeItem = this.block.options;
  },
  methods: {
    switchMenu(slug, id) {
      this.activeMenu = slug;
      this.activeItem = null;
      if (id) {
        this.activeSettings = this.settings.filter(
          it => it.el === slug
        )[0].children;
        this.activeItem =
          this.block.options[slug].filter(it => it.id === id)[0] || {};
      }
      if (slug === "general") {
        this.activeItem = this.block.options;
        this.activeSettings = this.settings.filter(it => it.type !== "array");
      }
    },
    afterUpload() {
      this.$emit("afterUpload");
    },
    addNew(arrayed) {
      const arr = this.block.options[arrayed.el];
      const lastObject = arr.reduce(
        (prev, current) => (prev.id > current.id ? prev : current)
      );
      const newEl = JSON.parse(JSON.stringify(lastObject));
      newEl.id += 1;
      arr.push(newEl);
      this.switchMenu(arrayed.el, newEl.id);
    },
    removeThis(arrayed, id) {
      this.block.options[arrayed.el] = this.block.options[arrayed.el].filter(
        e => e.id !== id
      );
      const lastId = this.block.options[arrayed.el].reduce(
        (prev, current) => (prev.id > current.id ? prev.id : current.id),
        0
      );
      if (lastId) {
        this.switchMenu(arrayed.el, lastId);
      } else {
        this.switchMenu("general", null);
      }
    },
    deleteBlock() {
      this.$emit("deleteBlock");
    },
    moveBlockDown() {
      this.$emit("moveBlockDown");
    },
    moveBlockUp() {
      this.$emit("moveBlockUp");
    },
    popSettingsOpen() {
      this.dialogOpen = true;
    },
    popSettingsClose() {
      this.dialogOpen = false;
      this.$emit("afterSettingsClose");
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/blocks/_BlockSettings.vue